import { render, staticRenderFns } from "./twofactor-action-footer.vue?vue&type=template&id=298c3843&scoped=true"
import script from "./twofactor-action-footer.vue?vue&type=script&lang=ts"
export * from "./twofactor-action-footer.vue?vue&type=script&lang=ts"
import style0 from "./twofactor-action-footer.vue?vue&type=style&index=0&id=298c3843&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298c3843",
  null
  
)

export default component.exports